export enum ServiceType {
  PERMITTING_DRAWING_AND_SUBMITTAL = "Permitting Service: Drawing & Submittal",
  PERMITTING_DRAWING_ONLY = "Permitting Service: Drawing Only",
  PERMITTING_SUBMITTAL_ONLY = "Permitting Service: Submittal Only",
}

export enum ProjectStatus {
  DRAFT = "draft",
  ON_HOLD = "on hold",
  PENDING = "pending",
  SUBMITTED = "submitted",
  IN_PROGRESS = "in progress",
  REJECTED = "rejected",
  COMPLETED = "completed",
}
